module.exports = __webpack_public_path__ + "static/MOD3-874388aa66989b2c319ded4a2de1f10d.jpg";